import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-8 md:py-12 px-4 bg-slate-900" data-id="element-247">
      <div className="max-w-3xl mx-auto" data-id="element-248">
        <FadeIn data-id="element-249">
          <h2 className="text-2xl md:text-4xl font-serif italic text-orange-500 text-center mb-6 font-bold leading-tight" data-id="element-250">
            ¿Cuánta plata más vas a tirar en pinturas que no resuelven nada?
          </h2>
        </FadeIn>

        <div className="space-y-4 text-base md:text-lg text-slate-300 leading-relaxed font-light" data-id="element-251">
          <FadeIn delay={0.1} data-id="element-252">
            <p data-id="element-253">
              Sabés lo que tenés. Pero comprás de oído, pintás y rezás. Y la
              humedad vuelve.
            </p>
          </FadeIn>

          <div className="py-4 pl-5 border-l-2 border-orange-500/50" data-id="element-254">
            <ul className="space-y-2" data-id="element-255">
              {['Pinturas anti-humedad que no resuelven nada', 'Hidrófugos comprados para el uso incorrecto', 'Presupuestos de empresa: $800.000 ARS por una habitación', 'No sabés si es condensación, filtración o napa'].map((item, i) => <FadeIn key={i} delay={0.2 + i * 0.1} direction="left" data-id="element-256">
                  <li className="flex items-start gap-3" data-id="element-257">
                    <span className="text-orange-500 mt-1 font-bold" data-id="element-258">❌</span>
                    <span className="text-slate-300" data-id="element-259">{item}</span>
                  </li>
                </FadeIn>)}
            </ul>
          </div>

          <FadeIn delay={0.6} data-id="element-260">
            <div className="mt-4 bg-slate-950 border border-orange-500/30 rounded-2xl p-5 md:p-6 text-center shadow-lg" data-id="element-261">
              <p className="text-xl md:text-2xl text-white font-bold" data-id="element-262">
                ¿Y si este fuera el último trabajo que hacés a ciegas?
              </p>
              <p className="text-sm md:text-base text-slate-400 mt-2" data-id="element-263">
                No es falta de voluntad.{' '}
                <span className="text-orange-500 font-bold" data-id="element-264">
                  Es falta de un sistema.
                </span>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}